import { isMobile,deviceDetect } from 'mobile-device-detect';

export function scrollTo(h, offset=0, callback = () => {}){
    $('html,body').animate({ scrollTop: h + offset }, 'slow', callback);
}

export function sublayerAction(){
    $('.sublayer').on("click", function(e){
        e.preventDefault();
        $('.menu').trigger('click');
    })
}

export function backToTop(){
    $('.back-to-top-action').on("click", function (e) {
        e.preventDefault();
        $('html,body').animate({ scrollTop: 0 }, 'slow');
        return false;
    });
}

export function scrollDown(){
    $('.scroll-down-action').on("click", function (e) {
        e.preventDefault();
        let position = $('.content-wrapper').offset();
        $('html,body').animate({ scrollTop: position.top }, 'slow');
    })
}

export function setBoxHeight(){
    let h = $(window).height();
    $('.fix').height(h);
}

export function ismobile(){
   return isMobile;
}

export function menuTrigger(){
    
    let ham = $('.hamburger');
    let menu = $('.menu');
    let sublayer = $('.sublayer');

    menu.on("click", function(e){
        e.preventDefault();
        ham.toggleClass('is-active');
        $('.submenu').toggleClass('is-show')
        $('body').toggleClass('no-overflow')
        menu.toggleClass('pulse')
        sublayer.toggleClass('is-show');
    })

}

export function initAnchorLinks(){
    let menu = $('.menu');
    $('.anchor').on("click", function(e){
        e.preventDefault()
        let ref = $(this).attr('href');
        let articleID = $(this).data('article');
        menu.trigger('click')
        let string = '?articolo='+articleID
        history.pushState(null, null, string);
        let el = $(ref).offset();
        let h = el.top;
        scrollTo(h);
    })
}

export function randomic(min, max){
        min = Math.ceil(min);
        max = Math.floor(max);
        return Math.floor(Math.random() * (max - min)) + min; 
}




